module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoicePayments":"Invoice Payments","method":"Method","deleteInvoicePayment":"Delete Invoice Payment","deleteInvoicePaymentText":"Confirm invoice payment deletion"},"al":{"invoicePayments":"Pagesat e fatures","method":"Metoda","deleteInvoicePayment":"Fshi pagesen e fatures","deleteInvoicePaymentText":"Konfirmoni fshirjen e pageses se fatures"}}')
  delete Component.options._Ctor
}
